import classNames from 'classnames/bind';
import styles from './LoginPage.module.scss';
import LoginForm from '~/component/LoginForm';
import useMeta from '~/hooks/useMeta';

const cx = classNames.bind(styles);

function LoginPage() {

  useMeta({
    title: 'Đăng Nhập - Blog | Ngô Gia Quyến',
    description: 'Đăng nhập vào blog để có thể quản lý bài viết.',
    keywords: 'đăng nhập, blog, ngô gia quyến',
    author: 'Ngô Gia Quyến',
    url: 'https://ngogiaquyen.id.vn/login',
  });

  return (
    <div className={cx('wrapper')}>
      <LoginForm />
    </div>
  );
}

export default LoginPage;
